import bankConsorcio from '../../banksPNG/bankConsorcio.png';

interface IconProps {
	width?: string;
	height?: string;
	alt?: string;
}

export const BancoConsorcioIcon = ({
	width = '17px',
	height = '17px',
	alt = 'Banco Consorcio',
}: IconProps) => <img src={bankConsorcio} width={width} height={height} alt={alt} />;
